import { useEffect, useRef } from 'react';

import { withAuth } from '@/components/auth-wrapper';
import Layout from '@/components/layouts/page-layout';
import { ProductView } from '@/components/product-view';
import { TawkChat } from '@/components/tawk-chat';
import Header from '@/components/ui-v2/header';
import Navigation from '@/components/ui-v2/navigation';
import { cn } from '@/lib/utils';
import { editingCellState } from '@/states/editing-cell.state';
import { fullscreenState } from '@/states/fullscreen.state';
import { useAtomValue, useSetAtom } from 'jotai';

export function DealPage() {
  const fullscreen = useAtomValue(fullscreenState);
  const setFullscreen = useSetAtom(fullscreenState);
  const editingCell = useAtomValue(editingCellState);
  const editingCellRef = useRef(editingCell);
  editingCellRef.current = editingCell;

  // Priorité Escape : 1) annuler édition cellule, 2) fermer modales (Radix), 3) quitter fullscreen.
  useEffect(() => {
    if (!fullscreen) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key !== 'Escape') return;
      if (editingCellRef.current !== null) return;
      setFullscreen(false);
    };

    window.addEventListener('keydown', handleKeyDown, true);
    return () => window.removeEventListener('keydown', handleKeyDown, true);
  }, [fullscreen, setFullscreen]);

  return (
    <Layout>
      <div
        className={cn(
          'flex h-screen w-screen flex-col',
          !fullscreen && 'overflow-y-auto'
        )}
      >
        {!fullscreen && (
          <>
            <div className="sticky top-0 z-navigation shrink-0 bg-white">
              <Navigation />
            </div>
            <Header />
            <hr className="mt-4 shrink-0 border-t border-gray-100" />
          </>
        )}

        <div className={cn('min-h-0 flex-1 px-10 ')}>
          <ProductView />
        </div>
      </div>
      <TawkChat />
    </Layout>
  );
}

export default withAuth(DealPage);
